import apiClient from '../helpers/apiClient'

// WP-X7 — member expertise tab reads (admin member-detail). Two sources:
//   1. The member's ExpertProfile (if they're an expert) — via X4's admin expert-profiles list,
//      filtered to this member client-side. BLOCKED on X4 deploy.
//   2. The member's engagements — needs an admin "by member" read; #43's list is self-scoped, so
//      this uses an EXPECTED admin filter (?user=<id>) that isn't in the deployed API yet.
//      BLOCKED on that backend addition. (Documented so it drops in when the endpoint lands.)
//
// Shapes (camelCased): ExpertProfile (full, X4 ExpertProfileSerializer) exposes
//   expertMember:{id,name,email}|null so we can match it to the member. Engagement = the #43
//   EngagementReadSerializer shape.

const ADMIN_EXPERT_PROFILES = '/expertise/admin/expert-profiles/'
const ENGAGEMENTS = '/expertise/engagements/'

export const getAdminExpertProfiles = async () => {
  const response = await apiClient.get(ADMIN_EXPERT_PROFILES)
  return response.data
}

// Expected admin filter: engagements a given member is a party to. Not in the deployed #43 list
// (self-scoped) — reconcile when the backend adds ?user=/an admin endpoint.
export const getMemberEngagements = async (userId: number | string) => {
  const response = await apiClient.get(ENGAGEMENTS, {params: {user: userId}})
  return response.data
}
